import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TAny } from "@app/lib/models/common.type";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { Observable } from "rxjs";
import { IDTypeResponse } from "../models/document-details.model";
import { AdminTypeResponse } from "../models/partydetails.model";


@Injectable({
    providedIn: 'root'
})
export class PartiesService extends BaseHttpService {

    constructor(
        http: HttpClient,
        appConfig: AppConfiguration,
    ) {
        super(http, appConfig);
    }
    searchParties(reqBody: TAny) {
        return this.post<IResponse<any>, TAny>('parties/fetch.htm', reqBody);
    }
    saveParties(reqBody: TAny) {
        return this.post<IResponse<any>, TAny>('parties/upsert.htm', reqBody);
    }
    savePartiesNew(reqBody: TAny) {
        return this.post<IResponse<any>, TAny>('parties/new/upsert.htm', reqBody);
    }
    saveContacts(reqBody: TAny) {
        return this.post<IResponse<any>, TAny>('parties/add-contact.htm', reqBody);
    }
    saveAddress(reqBody: TAny) {
        return this.post<IResponse<any>, TAny>('parties/add-address.htm', reqBody);
    }
    savePreviousName(reqBody: TAny) {
        return this.post<IResponse<any>, TAny>('parties/add-previous-name.htm', reqBody);
    }
    saveAliasName(reqBody: TAny) {
        return this.post<IResponse<any>, TAny>('parties/add-alias-name.htm', reqBody);
    }
    
    getIDTypes():Observable<IDTypeResponse> {
        return this.get<IDTypeResponse>('id-types/search.htm');
    }
    getContactTypes():Observable<IDTypeResponse> {
        return this.get<IDTypeResponse>('contact-info-types/fetch.htm');
    }
    getadminTypesCountry():Observable<AdminTypeResponse> {
        return this.get<AdminTypeResponse>('admin-units/get/country.htm');
    }
    getadminTypesPlace():Observable<AdminTypeResponse> {
        return this.get<AdminTypeResponse>('admin-units/get/birth-place.htm');
    }
    inactivateGroupParties(reqBody: TAny) {
        return this.post<IResponse<any>, TAny>('parties/delete/group-parties.htm', reqBody);
    }
}